import { CohortEnumSchema } from '@eigtech/auth0-types';
import { ClaimV2CornSchema } from '@eigtech/claims-v2-types';
import { DocumentCornSchema } from '@eigtech/documents-types';
import { TemplateCornSchema } from '@eigtech/templates-types';
import { z } from 'zod';
import { GuidedDocumentTypeSchema } from '../../base/guidedDocument.js';
import { StepFunctionTaskContextSchema } from '../request.js';
export const GatherTemplateTokensInputSchema = z.object({
    cohorts: CohortEnumSchema.array(),
    entityId: ClaimV2CornSchema,
    requestActor: z.string(),
    templateId: TemplateCornSchema,
    // #region Guided document only
    /** Guided document only */
    guidedDocument: z
        .object({
        documentCorns: DocumentCornSchema.array().optional(),
        guidedStatement: z.string().optional(),
        type: GuidedDocumentTypeSchema,
    })
        .optional(),
    // #endregion Guided document only
});
export const GatherTemplateTokensOutputSchema = z.object({
    gatherTemplateTokensResults: z.object({ tokens: z.array(z.string()) }),
});
export const GatherTemplateTokensRequestSchema = z.object({
    context: StepFunctionTaskContextSchema,
    input: GatherTemplateTokensInputSchema,
});
export const GatherTemplateTokensResponseSchema = GatherTemplateTokensOutputSchema.shape.gatherTemplateTokensResults;
